module.exports = {
	"ha": "bc",
	"id": 5.5,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q2–2018 Q1",
		"lastYear": "2018",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginLeft": 90,
			"marginTop": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 80px;\">Figure 5.5</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for BC by Age Category and MSM Status, Year Ending 2018 Q1 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "60%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "60%",
				"height": "40%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 92.02453987730061,
						"dataLabels": {
							"enabled": false,
							"format": "150"
						},
						"color": "#043f61"
					},
					{
						"y": 81.59509202453987,
						"dataLabels": {
							"enabled": false,
							"format": "133"
						},
						"color": "#0c4250"
					},
					{
						"y": 76.68711656441718,
						"dataLabels": {
							"enabled": false,
							"format": "125"
						},
						"color": "#0d4440"
					},
					{
						"y": 71.16564417177914,
						"dataLabels": {
							"enabled": false,
							"format": "116"
						},
						"color": "#09472e"
					},
					{
						"y": 63.80368098159509,
						"dataLabels": {
							"enabled": false,
							"format": "104"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.8944099378882,
						"dataLabels": {
							"enabled": false,
							"format": "468"
						},
						"color": "#043f61"
					},
					{
						"y": 82.40165631469979,
						"dataLabels": {
							"enabled": false,
							"format": "398"
						},
						"color": "#0c4250"
					},
					{
						"y": 77.4327122153209,
						"dataLabels": {
							"enabled": false,
							"format": "374"
						},
						"color": "#0d4440"
					},
					{
						"y": 72.2567287784679,
						"dataLabels": {
							"enabled": false,
							"format": "349"
						},
						"color": "#09472e"
					},
					{
						"y": 61.904761904761905,
						"dataLabels": {
							"enabled": false,
							"format": "299"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.93877551020408,
						"dataLabels": {
							"enabled": false,
							"format": "665"
						},
						"color": "#043f61"
					},
					{
						"y": 85.13119533527697,
						"dataLabels": {
							"enabled": false,
							"format": "584"
						},
						"color": "#0c4250"
					},
					{
						"y": 80.02915451895043,
						"dataLabels": {
							"enabled": false,
							"format": "549"
						},
						"color": "#0d4440"
					},
					{
						"y": 75.36443148688046,
						"dataLabels": {
							"enabled": false,
							"format": "517"
						},
						"color": "#09472e"
					},
					{
						"y": 66.1807580174927,
						"dataLabels": {
							"enabled": false,
							"format": "454"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98.91774891774891,
						"dataLabels": {
							"enabled": false,
							"format": "2285"
						},
						"color": "#043f61"
					},
					{
						"y": 90.51948051948052,
						"dataLabels": {
							"enabled": false,
							"format": "2091"
						},
						"color": "#0c4250"
					},
					{
						"y": 86.36363636363636,
						"dataLabels": {
							"enabled": false,
							"format": "1995"
						},
						"color": "#0d4440"
					},
					{
						"y": 83.07359307359307,
						"dataLabels": {
							"enabled": false,
							"format": "1919"
						},
						"color": "#09472e"
					},
					{
						"y": 74.5021645021645,
						"dataLabels": {
							"enabled": false,
							"format": "1721"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 94.91525423728814,
						"dataLabels": {
							"enabled": false,
							"format": "56"
						},
						"color": "#043f61"
					},
					{
						"y": 72.88135593220339,
						"dataLabels": {
							"enabled": false,
							"format": "43"
						},
						"color": "#0c4250"
					},
					{
						"y": 67.79661016949152,
						"dataLabels": {
							"enabled": false,
							"format": "40"
						},
						"color": "#0d4440"
					},
					{
						"y": 59.32203389830508,
						"dataLabels": {
							"enabled": false,
							"format": "35"
						},
						"color": "#09472e"
					},
					{
						"y": 44.06779661016949,
						"dataLabels": {
							"enabled": false,
							"format": "26"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.25360230547551,
						"dataLabels": {
							"enabled": false,
							"format": "334"
						},
						"color": "#043f61"
					},
					{
						"y": 87.89625360230548,
						"dataLabels": {
							"enabled": false,
							"format": "305"
						},
						"color": "#0c4250"
					},
					{
						"y": 79.2507204610951,
						"dataLabels": {
							"enabled": false,
							"format": "275"
						},
						"color": "#0d4440"
					},
					{
						"y": 64.84149855907782,
						"dataLabels": {
							"enabled": false,
							"format": "225"
						},
						"color": "#09472e"
					},
					{
						"y": 48.414985590778095,
						"dataLabels": {
							"enabled": false,
							"format": "168"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.98488664987406,
						"dataLabels": {
							"enabled": false,
							"format": "778"
						},
						"color": "#043f61"
					},
					{
						"y": 85.3904282115869,
						"dataLabels": {
							"enabled": false,
							"format": "678"
						},
						"color": "#0c4250"
					},
					{
						"y": 80.35264483627203,
						"dataLabels": {
							"enabled": false,
							"format": "638"
						},
						"color": "#0d4440"
					},
					{
						"y": 71.66246851385391,
						"dataLabels": {
							"enabled": false,
							"format": "569"
						},
						"color": "#09472e"
					},
					{
						"y": 51.13350125944584,
						"dataLabels": {
							"enabled": false,
							"format": "406"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98.02867383512545,
						"dataLabels": {
							"enabled": false,
							"format": "1641"
						},
						"color": "#043f61"
					},
					{
						"y": 88.59020310633214,
						"dataLabels": {
							"enabled": false,
							"format": "1483"
						},
						"color": "#0c4250"
					},
					{
						"y": 84.10991636798089,
						"dataLabels": {
							"enabled": false,
							"format": "1408"
						},
						"color": "#0d4440"
					},
					{
						"y": 77.95698924731182,
						"dataLabels": {
							"enabled": false,
							"format": "1305"
						},
						"color": "#09472e"
					},
					{
						"y": 61.94743130227002,
						"dataLabels": {
							"enabled": false,
							"format": "1037"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 48.986486486486484,
						"dataLabels": {
							"enabled": false,
							"format": "145"
						},
						"color": "#043f61"
					},
					{
						"y": 38.513513513513516,
						"dataLabels": {
							"enabled": false,
							"format": "114"
						},
						"color": "#0c4250"
					},
					{
						"y": 35.47297297297297,
						"dataLabels": {
							"enabled": false,
							"format": "105"
						},
						"color": "#0d4440"
					},
					{
						"y": 30.743243243243246,
						"dataLabels": {
							"enabled": false,
							"format": "91"
						},
						"color": "#09472e"
					},
					{
						"y": 22.972972972972975,
						"dataLabels": {
							"enabled": false,
							"format": "68"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 85.29980657640233,
						"dataLabels": {
							"enabled": false,
							"format": "441"
						},
						"color": "#043f61"
					},
					{
						"y": 64.21663442940039,
						"dataLabels": {
							"enabled": false,
							"format": "332"
						},
						"color": "#0c4250"
					},
					{
						"y": 58.41392649903289,
						"dataLabels": {
							"enabled": false,
							"format": "302"
						},
						"color": "#0d4440"
					},
					{
						"y": 50.870406189555126,
						"dataLabels": {
							"enabled": false,
							"format": "263"
						},
						"color": "#09472e"
					},
					{
						"y": 43.907156673114116,
						"dataLabels": {
							"enabled": false,
							"format": "227"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 86.78038379530916,
						"dataLabels": {
							"enabled": false,
							"format": "814"
						},
						"color": "#043f61"
					},
					{
						"y": 60.021321961620465,
						"dataLabels": {
							"enabled": false,
							"format": "563"
						},
						"color": "#0c4250"
					},
					{
						"y": 54.58422174840085,
						"dataLabels": {
							"enabled": false,
							"format": "512"
						},
						"color": "#0d4440"
					},
					{
						"y": 49.78678038379531,
						"dataLabels": {
							"enabled": false,
							"format": "467"
						},
						"color": "#09472e"
					},
					{
						"y": 40.93816631130064,
						"dataLabels": {
							"enabled": false,
							"format": "384"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 84.7645429362881,
						"dataLabels": {
							"enabled": false,
							"format": "1836"
						},
						"color": "#043f61"
					},
					{
						"y": 55.4016620498615,
						"dataLabels": {
							"enabled": false,
							"format": "1200"
						},
						"color": "#0c4250"
					},
					{
						"y": 51.43120960295475,
						"dataLabels": {
							"enabled": false,
							"format": "1114"
						},
						"color": "#0d4440"
					},
					{
						"y": 48.938134810710984,
						"dataLabels": {
							"enabled": false,
							"format": "1060"
						},
						"color": "#09472e"
					},
					{
						"y": 41.92059095106187,
						"dataLabels": {
							"enabled": false,
							"format": "908"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -7.975460122699385,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.333333333333329,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.015037593984962,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.199999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.344827586206895,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.105590062111796,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.95726495726496,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.030150753768848,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.68449197860963,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.32664756446992,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.0612244897959218,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.180451127819547,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.9931506849315035,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.828779599271405,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.185686653771766,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.0822510822510845,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.49015317286652,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.591104734576756,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.809523809523807,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.317873892652418,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -5.0847457627118615,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -23.214285714285708,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.976744186046513,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.5,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25.71428571428571,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.746397694524495,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.682634730538918,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.836065573770492,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.181818181818176,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25.33333333333333,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.015113350125941,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.853470437018,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.899705014749268,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.815047021943569,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -28.64674868189807,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.971326164874554,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.62827544180378,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.0573162508428915,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.3153409090909065,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -20.53639846743295,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -51.01351351351351,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -21.379310344827584,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.8947368421052655,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.33333333333333,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25.274725274725274,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -14.700193423597675,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -24.716553287981856,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.036144578313255,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.91390728476821,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.688212927756648,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -13.219616204690832,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -30.835380835380832,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.058614564831258,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.7890625,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -17.77301927194861,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -15.23545706371191,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -34.64052287581699,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.166666666666666,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.847396768402157,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.33962264150943,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 12,
				"y": 40,
				"text": "MSM"
			},
			{
				"x": 3,
				"text": "<30<br>n=163"
			},
			{
				"x": 9,
				"text": "30-39<br>n=483"
			},
			{
				"x": 15,
				"text": "40-49<br>n=686"
			},
			{
				"x": 21,
				"text": ">=50<br>n=2310"
			},
			{
				"x": 37,
				"y": 40,
				"text": "Non-MSM"
			},
			{
				"x": 28,
				"text": "<30<br>n=59"
			},
			{
				"x": 34,
				"text": "30-39<br>n=347"
			},
			{
				"x": 40,
				"text": "40-49<br>n=794"
			},
			{
				"x": 46,
				"text": ">=50<br>n=1674"
			},
			{
				"x": 62,
				"y": 40,
				"text": "Unknown"
			},
			{
				"x": 53,
				"text": "<30<br>n=296"
			},
			{
				"x": 59,
				"text": "30-39<br>n=517"
			},
			{
				"x": 65,
				"text": "40-49<br>n=938"
			},
			{
				"x": 71,
				"text": ">=50<br>n=2166"
			}
		],
		"dataTable": {
			"MSM:<30": [
				163,
				150,
				133,
				125,
				116,
				104
			],
			"MSM:30-39": [
				483,
				468,
				398,
				374,
				349,
				299
			],
			"MSM:40-49": [
				686,
				665,
				584,
				549,
				517,
				454
			],
			"MSM:>=50": [
				2310,
				2285,
				2091,
				1995,
				1919,
				1721
			],
			"Non-MSM:<30": [
				59,
				56,
				43,
				40,
				35,
				26
			],
			"Non-MSM:30-39": [
				347,
				334,
				305,
				275,
				225,
				168
			],
			"Non-MSM:40-49": [
				794,
				778,
				678,
				638,
				569,
				406
			],
			"Non-MSM:>=50": [
				1674,
				1641,
				1483,
				1408,
				1305,
				1037
			],
			"Unknown:<30": [
				296,
				145,
				114,
				105,
				91,
				68
			],
			"Unknown:30-39": [
				517,
				441,
				332,
				302,
				263,
				227
			],
			"Unknown:40-49": [
				938,
				814,
				563,
				512,
				467,
				384
			],
			"Unknown:>=50": [
				2166,
				1836,
				1200,
				1114,
				1060,
				908
			]
		}
	},
	"callback": "C:\\Users\\Rafael\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_5_5.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_bc_5_5.json
// module id = 168
// module chunks = 0